import * as React from 'react';
import CalendarText from '../../contexts/calendar-text';
import moment = require('moment');
import { formatDateTime } from '../../helpers/format-date-time';

const monthFormat = "MMMM YYYY";

export interface MiniCalendarControlsViewProps {
    currentMonth: moment.Moment;
    handleNextMonthClick: () => void;
    handlePreviousMonthClick: () => void;
    handleMonthChange: (evt: React.ChangeEvent<HTMLSelectElement>) => void;
    handleTodayClick: () => void;
    handleTodayTab: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
    nextMonthRef: React.RefObject<HTMLButtonElement>;
    previousMonthRef: React.RefObject<HTMLButtonElement>;
    todayRef: React.RefObject<HTMLButtonElement>;
    displayPreviousMonth: boolean;
    validMonths: moment.Moment[];
}

/**
 * The controls interface for navigating between months, includes helpful instructions for keyboard / SR users.
 */
export const MiniCalendarControlsView: React.FunctionComponent<MiniCalendarControlsViewProps> = (props) => {
    return (
        <CalendarText.Consumer>
            {text => (
                <>
                    <a href="#Events_Header" className="mini-cal-skip-link">{text.skipToEventsButtonText}</a>
                    <h2 className="visually-hidden" id="MiniCal_Heading">{text.miniCalendarHiddenHeading}</h2>
                    <p className="mini-cal-nav-instructions mini-cal-skip-link" tabIndex={0}>
                        {text.keyboardInstructions}
                    </p>
                    <div className="mini-cal-month">
                        <h3 className="visually-hidden">{formatDateTime(props.currentMonth, monthFormat)}</h3>
                        <div className="stack-xs mini-cal-month-header">
                            <label htmlFor="MonthDropdown">{text.monthDropdownDescriptionText}</label>
                            <select value={props.currentMonth.format("X")} id="MonthDropdown" onChange={props.handleMonthChange}>
                                {
                                    props.validMonths.map(month => <option key={month.format("X")} value={month.format("X")}>{month.format(monthFormat)}</option>)
                                }
                            </select>
                        </div>
                    </div>
                </>
            )}
        </CalendarText.Consumer>
    )
}
